import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "py-4 section-app" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "row mx-n2" }
const _hoisted_4 = { class: "col-lg-6 px-2" }
const _hoisted_5 = { class: "card mt-2" }
const _hoisted_6 = {
  class: "table-responsive",
  style: {"max-height":"calc(100vh - 182px)","height":"100vh"}
}
const _hoisted_7 = { class: "table table-menu m-0" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-dark text-white" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "No"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Waktu"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Nomor Nota"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Nomor Meja"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Big Boss"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Total"),
    /*#__PURE__*/_createElementVNode("th", {
      width: "120",
      class: "text-center"
    }, "Aksi")
  ])
], -1)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "7" }, "Data tidak ditemukan")
], -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "text-center" }
const _hoisted_14 = { class: "text-center" }
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = { class: "text-center" }
const _hoisted_17 = { class: "text-center" }
const _hoisted_18 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Nav = _resolveComponent("Nav")!
  const _component_HistoryDetail = _resolveComponent("HistoryDetail")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Nav),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("table", _hoisted_7, [
                  _hoisted_8,
                  (_ctx.historyEmpty)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_9, _hoisted_11))
                    : _createCommentVNode("", true),
                  (!_ctx.historyEmpty)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_12, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.histories, (history, index) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: index,
                            class: _normalizeClass(_ctx.getRowClass(history.m_transaction_table_id))
                          }, [
                            _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                            _createElementVNode("td", null, _toDisplayString(history.time), 1),
                            _createElementVNode("td", _hoisted_13, _toDisplayString(history.m_transaction_table_note_number), 1),
                            _createElementVNode("td", _hoisted_14, _toDisplayString(history.m_transaction_table_table_name_list), 1),
                            _createElementVNode("td", _hoisted_15, _toDisplayString(history.m_transaction_table_customer_name), 1),
                            _createElementVNode("td", _hoisted_16, _toDisplayString(history.nominal_pembulatan), 1),
                            _createElementVNode("td", _hoisted_17, [
                              _createElementVNode("button", {
                                class: "btn btn-primary font-weight-bold btn-sm",
                                type: "button",
                                onClick: ($event: any) => (_ctx.onLoadHistoryDetailClick(history.m_transaction_table_id))
                              }, "Lihat Detail", 8, _hoisted_18)
                            ])
                          ], 2))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          _createVNode(_component_HistoryDetail, {
            historyDetails: _ctx.historyDetail,
            typeMenu: _ctx.menuJenis,
            showDetail: _ctx.showHistoryDetail
          }, null, 8, ["historyDetails", "typeMenu", "showDetail"])
        ])
      ])
    ])
  ]))
}